import utils from '../../utils/util';
import { URLService } from '../url.service';
import { DealerShareBuilder } from './dealer.share';
export class AdviserShareBuilder extends DealerShareBuilder {
  constructor ({ dealerInfo, adviserInfo, shareInfo }) {
    super({ dealerInfo, shareInfo });
    this.adviserInfo = adviserInfo;
  }
  getPvareaId () {
    let pvareaid = 6836256;
    if (utils.browser.isApp) {
      pvareaid = 6836171;
    } else if (utils.browser.isPriceApp) {
      pvareaid = utils.browser.isIos ? 2594113 : 2594114;
    }
    return pvareaid;
  }
  buildShareData () {
    const adviserInfo = this.adviserInfo;
    let pvareaid = this.getPvareaId();
    const urlService = new URLService(window.location.href);
    urlService.fragment = '';
    urlService.queryParams.remove('userid', true).remove('pvareaid', true).append('userid', adviserInfo.userId).append('pvareaid', pvareaid);
    const shareTitle = `买好车就找我，${adviserInfo.salesName}带您看车问价一站式服务。`;
    let imageUrl = adviserInfo.photoUrl;
    if (!adviserInfo.photoUrl && this.shareInfo && this.shareInfo.dealerImage) {
      imageUrl = this.shareInfo.dealerImage;
    }
    const shareUrl = urlService.build();
    return {
      title: shareTitle,
      icon: imageUrl,
      link: shareUrl
    };
  }
}